const d3 = require("d3");

// 100 maximally distinct colors
const colors = d3.scaleOrdinal().range([
    "#7A2719", "#5CE33C", "#E146E9", "#64C6DE", "#E8B031", "#322755", "#436521",
    "#DE8EBA", "#5C77E3", "#CEE197", "#E32C76", "#E54229", "#2F2418", "#E1A782",
    "#788483", "#68E8B2", "#9E2B85", "#E4E42A", "#D5D9D5", "#76404F", "#589BDB",
    "#E276DE", "#92C535", "#DE6459", "#E07529", "#A060E4", "#895997", "#7ED177",
    "#916D46", "#5BB0A4", "#365167", "#A4AE89", "#ACA630", "#38568F", "#D2B8E2",
    "#AF7B23", "#81A158", "#9E2F55", "#57E7E1", "#D8BD70", "#316F4B", "#5989A8",
    "#D17686", "#213F2C", "#A6808E", "#358937", "#504CA1", "#AA7CDD", "#393E0D",
    "#B02828", "#5EB381", "#47B033", "#DF3EAA", "#4E191E", "#9445AC", "#7A691F",
    "#382135", "#709628", "#EF6FB0", "#603719", "#6B5A57", "#A44A1C", "#ABC6E2",
    "#9883B0", "#A6E1D3", "#357975", "#DC3A56", "#561238", "#E1C5AB", "#8B8ED9",
    "#D897DF", "#61E575", "#E19B55", "#1F303A", "#A09258", "#B94781", "#A4E937",
    "#EAABBB", "#6E617D", "#B1A9AF", "#B16844", "#61307A", "#ED8B80", "#BB60A6",
    "#E15A7F", "#615C37", "#7C2363", "#D240C2", "#9A5854", "#643F64", "#8C2A36",
    "#698463", "#BAE367", "#E0DE51", "#BF8C7E", "#C8E6B6", "#A6577B", "#484A3A",
    "#D4DE7C", "#CD3488",
  ]);

export { colors };
